import userQueryHooks from './userQueryHooks.ts';
import fastspringQueryHooks from './fastspringQueryHooks.ts';
import recallQueryHooks from './recallQueryHooks.ts';
import tradingPartnerQueryHooks from './tradingPartnerQueryHooks.ts';
import verifiedTradingPartnerQueryHooks from './verifiedTradingPartner.ts';
import medQueryHooks from './medQueryHooks.ts';
import customerLocationQueryHooks from './customerLocation.ts';
import documentExceptionHooks from './documentException.ts';
import orderQueryHooks from './orderQueryHooks.ts';
import outboundDocumentHooks from './outboundDocument.ts';
import illegitReportHooks from './illegitReport.ts';
import outoundDocumentStatusHooks from './outboundDocumentStatus.ts';

export default {
  customerLocation: customerLocationQueryHooks,
  fastspring: fastspringQueryHooks,
  med: medQueryHooks,
  recall: recallQueryHooks,
  tradingPartner: tradingPartnerQueryHooks,
  verifiedTradingPartner: verifiedTradingPartnerQueryHooks,
  user: userQueryHooks,
  documentException: documentExceptionHooks,
  order: orderQueryHooks,
  outboundDocument: outboundDocumentHooks,
  illegitReport: illegitReportHooks,
  outboundDocumentStatus: outoundDocumentStatusHooks,
};
